import styled from "styled-components";

import { ProductPresentationFeatureCardContainer } from "../../atoms/PresentationFeatureCards/styles";

export const PresentationFeaturesSectionContainer = styled.section`
  display: flex;
  justify-content: center;
  flex-direction: column;

  margin: 3rem 0;

  gap: 1rem;

  @media (min-width: 980px) {
    flex-direction: row;
    margin: 5rem 0;
  }

  @media (min-width: 1300px) {
    gap: 2rem;
  }

  ${ProductPresentationFeatureCardContainer} {
    max-width: 80%;
    align-self: center;
  }
`;

export const PresentationFeaturesSectionContentFallback = styled.div`
  height: 15.625rem;
  width: 100%;
`;
